<template>
<div>
      <page-title-bar></page-title-bar>
		<v-container fluid pt-0 grid-list-xl>
<v-layout row wrap>
            	<app-card 
						:heading="Migratie - support"
						colClasses="xl12 lg12 md12 sm12 xs12"
						customClasses="mb-0">

                        <v-btn color="success" @click="migrateMenu" name="nmmigrateMenu" class="text-xs-right" :disabled="disable">Migratie menu</v-btn>
 
  </app-card>
</v-layout>
		</v-container>
        </div>
</template>
<script>

import myHttpApi from "../../api/myHttpApi";
import router from '../../router';

export default {
  components: {
  },
  data() {
    return {
      disable : false
    };
  },
  mounted() {
  },
  methods: {
    migrateMenu () {
        console.log ("migratemenu");
        this.disable = true;
        //BOSettings/SupportMigrateMenu

         myHttpApi.post('BOSettings/SupportMigrateMenu', "")
          .then(response => {
             this.disable = true;
          })
          .catch(error => {
            console.log(error);
          });
    }
  }
};
</script>